import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  count: {
  },
  price: {
  }
}))

export {
  useStyles
}
